import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import React from "react";
import { FileResult } from "../../models/AdminProductsModels";
import Loader from "../../../shared/components/Loader";
import useTranslation from "../../../shared/hooks/useTranslation";

interface ProductBatchResultDialogProps {
  error: any;
  open: boolean;
  onClose: () => void;
  fileResult: FileResult | undefined;
  loading: boolean;
}

const ProductBatchResultDialog = ({ error, open, onClose, fileResult, loading }: ProductBatchResultDialogProps) => {
  const { translate: tCommon } = useTranslation('common');
  const { translate: tInventory } = useTranslation('inventory');

  const theme = createTheme({
    components: {
      MuiDialog: {
        styleOverrides: {
          root: {
            ".MuiDialogContent-root": {
              padding: "0 24px 20px",
            },

            ".MuiDialogTitle-root": {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            },

            ".MuiPaper-root": {
              width: "480px",
              display: "flex",
              justifyContent: "center",
            },
          },
        },
      },
    },
  });

  if (loading) {
    return <Loader />
  }

  return (
    <>
      <ThemeProvider theme={theme}>
        <Dialog open={open} onClose={onClose}>
          <DialogTitle className="heading-2">
            <p className={error ? "danger" : "success"}>{error ? tCommon("uploadFile.fileUploadFailed") : tCommon("uploadFile.fileUploaded")}</p>
          </DialogTitle>

          <DialogContent>
            <Divider></Divider>

            {!error && fileResult && fileResult.messages?.length > 0 && (
              <div className="text-20-regular">
                <p className="mt-6" style={{ color: "#747881" }}>
                  {tInventory("productsAdded")}: <strong style={{ color: "#333333" }}>{fileResult.processedCount}</strong>
                </p>

                <p className="mt-6">{tInventory("someErrorsInTheFile")}</p>

                <div className="uplod-file-errors text-20-medium mt-6">
                  <ul>
                    {fileResult.messages.map((message, index) => (
                      <li key={"result-message-" + index}>
                        {message.text}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {!error && fileResult && fileResult.messages?.length < 1 && (
              <div className="text-20-regular">
                <p className="mt-6">{tInventory("fileUploaded")}</p>
                <p className="mt-6" style={{ color: "#747881" }}>
                  {tInventory("productsProcessed")}: <strong style={{ color: "#333333" }}>{fileResult.processedCount}</strong>
                </p>
              </div>
            )}

            {error && (
              <div className="text-20-regular">
                <p className="mt-6" style={{ color: "#747881" }}>
                  {tInventory("somethingWentWrong")}
                </p>
                <p className="mt-6">
                  {tInventory("productsAdded")}: <strong style={{ color: "#333333" }}>0</strong>
                </p>
              </div>
            )}
          </DialogContent>

          <DialogActions>
            <Button variant="contained" className="w-full" onClick={onClose}>
              {error ? tInventory("tryToUploadTheFileAgain") : tCommon("buttons.ok")}
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    </>
  );
};

export default ProductBatchResultDialog;
